import useAuthStore from '@/store/useAuthStore'
import axios from 'axios'
import { toast } from 'sonner'

const ERROR_RESPONSE = {
  403: 'You are not authorised to perform this action',
  404: 'Requested resource not found',
  500: 'Oops, unexpected error happened. We are looking into it',
}

const httpClient = axios.create({
  baseURL: `${import.meta.env.VITE_API_URL}/api/v1`,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  },
  withCredentials: true,
  withXSRFToken: true,
  validateStatus: function (status) {
    const success = status >= 200 && status < 300
    return success
  },
})

httpClient.defaults.withCredentials = true
httpClient.defaults.withXSRFToken = true

// Add a response interceptor
httpClient.interceptors.response.use(
  function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response
  },
  async function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error

    const statusCode = error?.response?.status
    // If unauthorized, show the error and redirect to the login page

    if ([401].includes(statusCode)) {
      toast.error(error?.response?.data?.message ?? 'An error occurred.')
      useAuthStore.setState({ isAuthenticated: false })

      setTimeout(() => {
        window.location.href = '/login'
      }, 1000)
    }

    if ([419].includes(statusCode)) {
      // if csrf token is expired, then make a request to get a new token using the /csrf-cookie endpoint
      await httpClient.get('/csrf-cookie')
      // retry the original request
      return httpClient.request(error.config)
    }

    // if ([419].includes(statusCode)) {
    //   toast.error(error?.response?.data?.message ?? 'An error occurred.')
    //   useAuthStore.setState({ isAuthenticated: false })
    // }

    if (statusCode === 421) {
      // Insufficient subscription — redirect straight to billing, no retry
      window.location.href = '/account?section=billing'
      return Promise.reject(error)
    }

    // If 422 - Validation error
    if (statusCode === 422) {
      // and no specific fields mentioned.
      if (!error?.response?.data?.errors) {
        toast.error(error?.response?.data?.message ?? 'An error occurred.')
      } else {
        error.hasFieldError = true
      }
    } else if (statusCode !== 500 && error?.response?.data?.message) {
      toast.error(error?.response?.data?.message)
    } else if (ERROR_RESPONSE[statusCode]) {
      toast.error(ERROR_RESPONSE[statusCode])
    } else {
      toast.error(error?.response?.data?.message ?? 'An error occurred.')
    }

    return Promise.reject(error)
  },
)

// const csrfTokenInterceptor = async (config) => {
//   try {
//     if (config.url === '/csrf-cookie') return config
//     // 2. Make a separate request to fetch the CSRF token
//     await httpClient.get('/csrf-cookie')
//   } catch (error) {
//     console.error('Error fetching CSRF token:', error)
//     // You might want to throw an error to prevent the main API request
//   }

//   return config
// }

// httpClient.interceptors.request.use(csrfTokenInterceptor)

// httpClient.defaults.headers['Authorization'] = `Bearer ${localStorage.getItem(
//   'token',
// )}`
// httpClient.defaults.headers.common['Authorization'] =
//   `Bearer ${localStorage.getItem('token')}`

export default httpClient
